import { Component, OnInit } from '@angular/core';
import { Plan, PlanDetail } from '../../interfaces';
import { UiServices } from 'src/app/services/ui-services';
import { PlanDetailComponent } from './status-components/plan-detail/plan-detail.component';
import { HttpService } from 'src/app/services/http.service';
import { BalanceService } from 'src/app/services/balance.service';

@Component({
  selector: 'app-status-account',
  templateUrl: './status-account.page.html',
  styleUrls: ['./status-account.page.scss'],
})
export class StatusAccountPage implements OnInit {
  public plans: any[] = [];
  public planDetail?: PlanDetail;
  public statements: Plan[] = [];
  public totalPages = 1;

  public initialFilters = {
    subscriptionId: '',
    pag: 1,
  };

  constructor(
    private uiSv: UiServices,
    private httpSv: HttpService,
    public balanceSv: BalanceService
  ) {}

  async ngOnInit() {
    const res = await this.httpSv.itemIndex(
      'learning',
      '',
      {},
      'mySubscription'
    );
    this.plans = res.data;
    this.getStatement();
  }

  async getStatement() {
    const res = await this.httpSv.itemIndex(
      'learning',
      '',
      this.initialFilters,
      'statement'
    );
    const data = res.data;
    data.data.forEach((item) => {
      const dues = item.dues;
      if (dues === 1 && item.inscription?.subscription?.includesDues) {
        item.motive = `Inscripción + Cuota ${dues}`;
      } else if (dues > 0) {
        item.motive = `Cuota ${dues}`;
      } else if (dues === 0) {
        item.motive = 'Inscripción';
      }
    });
    this.totalPages = data.meta.last_page;
    this.statements = data.data;
    this.planDetail = data.subDetails;
  }

  async changePage(page: number) {
    this.initialFilters.pag = page;
    this.getStatement();
  }

  setPlan(ev: Event) {
    const planId = (ev.target as HTMLIonSelectElement).value;
    this.initialFilters.subscriptionId = planId;
    this.initialFilters.pag = 1;
    this.getStatement();
  }

  async showDetail(statement: Plan) {
    this.uiSv.showPopover(PlanDetailComponent, { statement }, 'plan-detail');
  }
}
